<template>
   <div v-if="Object.keys(analytics).length !== 0">
      <div  class="row">
        <div class="col-xs-12 col-md-5 col-md-offset-1">
          <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
            <div class="ss-titre">
                <strong>Nombre de visiteurs nouveaux</strong>
            </div>
            <div class="portlet-body">
              <div class="portlet light">
                <div class="row">
                  <div class="col-xs-6">
                    <button
                      class="btn btn-primary btn-block btnCustom"
                      @click="checkNewVisitors(analytics.visitorsVsNew.OneDay)"
                      >
                      Aujourd'hui
                    </button>
                    <button
                      class="btn btn-primary btn-block btnCustom"
                      @click="checkNewVisitors(analytics.visitorsVsNew.OneWeek) & $event.target.classList.toggle(':active')"
                      >
                      Cette semaine
                    </button>
                    <button
                      class="btn btn-primary btn-block btnCustom"
                      @click="checkNewVisitors(analytics.visitorsVsNew.OneMonth)"
                      >
                      Ce mois-ci
                    </button>
                  </div>
                  <div class="col-xs-6 text-center counterSize">
                    <ICountUp
                      :endVal="newVisitors"
                      :options="options"
                        />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-5">
          <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
            <div class="ss-titre">
                <strong>Nombre de visiteurs connus</strong>
            </div>
            <div class="portlet-body">
              <div class="portlet light">
                <div class="row">
                  <div class="col-xs-6">
                    <button
                      class="btn btn-primary btn-block btnCustom"
                      @click="checkReturnVisitors(analytics.visitorsVsNew.OneDay)"
                      >
                      Aujourd'hui
                    </button>
                    <button
                      class="btn btn-primary btn-block btnCustom"
                      @click="checkReturnVisitors(analytics.visitorsVsNew.OneWeek)"
                      >
                      Cette semaine
                    </button>
                    <button
                      class="btn btn-primary btn-block btnCustom"
                      @click="checkReturnVisitors(analytics.visitorsVsNew.OneMonth)"
                      >
                      Ce mois-ci
                    </button>
                  </div>
                  <div class="col-xs-6 text-center counterSize">
                    <ICountUp
                        :endVal="returningVisitors"
                        :options="options"
                      />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-10 col-md-offset-1">
          <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
            <div class="ss-titre">
                <strong>Nombre de clicks sur vos partenaires</strong>
            </div>
            <div class="portlet-body">
              <div class="portlet light" style="margin-bottom : 0!important">
                <div v-for="partners in analytics.eventClick.OneYear" :key="partners.index">
                  <p class="partners">{{partners[0]}} : <span class="partners-click pull-right">{{partners[1]}}</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-10 col-md-offset-1">
          <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
            <div class="ss-titre">
                <strong>Nombre de visiteurs et de pages vues</strong>
            </div>
            <div class="portlet-body">
              <div class="portlet light">
                <div class="form-group" >
                  <div class="col-md-6 col-sm-6 customSelect">
                    <label>Choisir une période:</label>
                    <select class="form-control input-small" v-model="periode" @change="lineChartIndex++">
                      <option :value="analytics.visitorsAndViews.OneDay">24 heures</option>
                      <option :value="analytics.visitorsAndViews.OneWeek">1 semaine</option>
                      <option :value="analytics.visitorsAndViews.OneMonth">1 mois</option>
                    </select>
                  </div>
                </div>
                <div>
                  <line-chart :datasLineChart="periode" :key="lineChartIndex" :styles="lineStyle"></line-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-3 col-md-offset-1">
          <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
            <div class="ss-titre">
                <strong>Acquisition</strong>
            </div>
            <div class="portlet-body">
              <div class="portlet light" style="padding: 0">
                <div class="form-group" >
                  <div class="col-md-6 col-sm-6 customSelect">
                    <label>Choisir une période:</label>
                    <select class="form-control input-small" v-model="periodeReferrers" @change="donutsChartIndex++">
                      <option :value="{data: analytics.topReferrers.OneWeek, period: 'OneWeek'}">1 semaine</option>
                      <option :value="{data: analytics.topReferrers.OneMonth, period: 'OneMonth'}">1 mois</option>
                      <option :value="{data: analytics.topReferrers.SixMonth, period: 'SixMonth'}">6 mois</option>
                      <option :value="{data: analytics.topReferrers.OneYears, period: 'OneYears'}">1 an</option>
                    </select>
                  </div>
                </div>
                <div>
                  <donuts-chart :datasDonutsChart="periodeReferrers.data" :key="donutsChartIndex"></donuts-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-7">
          <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
            <div class="ss-titre">
              <strong>Taux de rebond par rapport à l'aquisition</strong>&nbsp;
              <span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true" :data-original-title="tooltip">
                <i class="icon-info"></i>
              </span>
              <span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true" :data-original-title="tooltip">
                <i class="icon-info"></i>
              </span>
            </div>
            <div class="portlet-body">
              <div class="portlet light" style="padding-bottom: 2px">
                <div>
                  <bar-chart-two :datasBarChart="analytics.referrersVsBounce[periodeReferrers.period]" :styles="barStyleBounce" :key="donutsChartIndex" ></bar-chart-two>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-10 col-md-offset-1">
          <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
            <div class="ss-titre">
                <strong>Pages les plus visitées</strong>
            </div>
            <div class="portlet-body">
              <div class="portlet light">
                <div class="form-group" >
                  <div class="col-md-6 col-sm-6 customSelect" style="padding-bottom: 1.5rem;">
                    <label>Choisir une période:</label>
                    <select class="form-control input-small" v-model="periodeVisited" @change="barChartOneIndex++">
                      <option :value="analytics.mostVisitedPages.OneWeek">Une semaine</option>
                      <option :value="analytics.mostVisitedPages.OneMonth">1 mois</option>
                      <option :value="analytics.mostVisitedPages.SixMonth">6 mois</option>
                      <option :value="analytics.mostVisitedPages.OneYears">1 an</option>
                    </select>
                  </div>
                </div>
                <div>
                  <bar-chart-one :datasBarChart="periodeVisited" :key="barChartOneIndex" :styles="barStyle"></bar-chart-one>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div>
          <div class="col-xs-12 col-md-3 col-md-offset-1">
            <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
              <div class="ss-titre">
                  <strong>Durée moyenne d'une session</strong>
              </div>
              <div class="portlet-body">
                <div class="portlet light" style="padding-bottom: 0!important; margin-bottom: 15px">
                  <div class="row">
                    <div class="col-xs-12">
                      <button
                        class="btn btn-primary btn-block btnCustom"
                        @click="checkAvgSession('OneWeek')"
                        >
                        Cette semaine
                      </button>
                      <button
                        class="btn btn-primary btn-block btnCustom"
                        @click="checkAvgSession('OneMonth')"
                        >
                        Ce mois-ci
                      </button>
                      <button
                        class="btn btn-primary btn-block btnCustom"
                        @click="checkAvgSession('OneYear')"
                        >
                        Cette année
                      </button>
                    </div>
                    <div class="col-xs-12 text-center session">
                      <ICountUp
                            :endVal="sessionDuration"
                            :options="options"
                          />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
              <div class="ss-titre">
                  <strong>Ton espace Google Analytics</strong>
              </div>
              <div class="portlet-body">
                <div class="portlet light" style="padding-top: 5px!important; margin-bottom: 5px">
                  <div class="row">
                    <div class="col-xs-12">
                      <a class="btn green btn-block btnCustom" href="https://analytics.google.com" target="_blank">Accéder à Google Analytics</a>
                      <a class="btn green btn-block btnCustom" @click="send">Modifier ses ID Analytics</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-7">
          <div style="border: 1px solid #C2CAD8; margin-right: 1em; padding: 1em; margin-bottom: 1em;">
            <div class="ss-titre">
                <strong>Durée moyenne d'une session par pages</strong>
            </div>
            <div class="portlet-body">
              <div class="portlet light" style="padding-bottom: 0!important; padding-top: 5px!important;">
                <div>
                  <bar-chart-three :datasBarChart="avgSessionVsPages" :key="barChartThreeIndex" :styles="barStyleSession"></bar-chart-three>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import LineChart from './lineChart.js'
import DonutsChart from './donutsChart.js'
import BarChartOne from './barChartForPages.js'
import BarChartTwo from './barChartForBounce.js'
import BarChartThree from './barChartForAvgSession.js'
import BarChartFour from './barChartClick.js'
import ICountUp from 'vue-countup-v2';
export default {
  name: 'allCharts',
  props: {
    office: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data () {
    return {
      analytics:{},
      urlHash: window.location.origin + window.location.pathname + '#tab_1_7',
      tooltip: "<div id='tooltip'><p id='text'><img src='/img/Encouragement-tooltip.png'>Pourcentage de sessions avec consultation d'une seule page de ton site au cours desquelles aucune interaction n'a été enregistrée. Une session avec rebond dure 0 seconde</p></div>",
      barChartOneIndex: 1,
      barChartThreeIndex: 1,
      lineChartIndex: 1,
      donutsChartIndex: 1,
      newVisitors: 0,
      returningVisitors: 0,
      periodeReferrers: {
        data: [],
        periode: ''
      },
      periodeVisited: [],
      periodeReferrersVsBounce: [],
      sessionDuration: 0,
      avgSessionVsPages: [],
      periode: [],
      lineStyle: {
        height: '350px',
        padding: '2rem, 0',
      },
      barStyle: {
        height: '380px',
      },
      barStyleBounce: {
        height: '375px'
      },
      barStyleSession: {
        height: '393px'
      },
      options: {
          useEasing: true,
      }
    }
  },
  components: {
    LineChart,
    DonutsChart,
    BarChartOne,
    BarChartTwo,
    BarChartThree,
    BarChartFour,
    ICountUp
  },
  mounted(){
    $('a[data-toggle="tab"]').on('shown.bs.tab',(e)=>{
      if($(e.target).attr('href') == '#tab_1_8'){
        axios.get('/office/'+this.office.id+'/analytics')
          .then(response => {
            this.analytics=response.data
          })
      }
    })
  },
  methods: {
    async send() {
      this.office.ga_view_id = null
      this.office.ga_tracking_id = null
      await axios.put(`/office/${this.office.id}`, this.office)
      window.setTimeout(window.location = this.urlHash, 400)
      window.setTimeout(window.location.reload.bind(window.location), 500)
      this.$snotify.success('Vos identifiants ont été réinitialisés')
    },
    checkNewVisitors(visitorsArray) {
      if (visitorsArray != null && visitorsArray.length === 1) {
        visitorsArray[0][0] === 'New Visitor' ? this.newVisitors = parseInt(visitorsArray[0][1]) : this.newVisitors = 0
      } else if (visitorsArray != null) {
        this.newVisitors = parseInt(visitorsArray[0][1])
      } else {
        this.newVisitors = 0
      }
    },
    checkReturnVisitors(visitorsArray) {
      if (visitorsArray != null && visitorsArray.length === 1) {
        visitorsArray[0][0] === 'Returning Visitor' ? this.returningVisitors = parseInt(visitorsArray[0][1]) : this.returningVisitors = 0
      } else if (visitorsArray != null) {
        this.returningVisitors = parseInt(visitorsArray[1][1])
      } else {
        this.returningVisitors = 0
      }
    },
    checkAvgSession(param) {
      this.sessionDuration = (this.analytics.avgSession[param]) / 60
      this.avgSessionVsPages = this.analytics.avgSessionVsPages[param]
      this.barChartThreeIndex++
    }
  }
}
</script>

<style lang="css" scoped>
.mt-1{
  margin-top: .4rem
}
#line-charts {
  height: 350px!important;
  padding-bottom: 3rem!important;
}
.counterSize > span {
  font-size: 350%;
  position: absolute;
  top: 50%;
  left:50%;
  transform: translate(-30%,21%);
  text-shadow: 1.5px 1.5px #d5d5d5
}
.counterSize {
  position: relative;
}
.session {
  padding-top: 1.7rem;
}
.session > span {
  font-size: 350%;
}
.session > span:after {
  content: 'min';
  font-size: 50%;
}
.btnCustom:focus {
  background-color: #6cb182!important;
}
.btnCustom {
  transition: background-color .5s linear
}
.customSelect {
  margin-top: -26px;
}
.partners {
  padding: 1.5rem .5rem;
  border: 1px solid #2A606C;
  font-size: 150%;
  background-color: #91B0B3;
  border-radius: 2px!important;
  position: relative;
  box-shadow: 1px 1px 14px -1px rgba(0,0,0,0.50);
}

.partners-click {
  font-size: 200%;
  position: absolute;
  top: 0%;
  left: 95%;
  text-shadow: 1px 1px #2A606C
}
</style>